module.exports = __webpack_public_path__ + "static/media/bristol_Myers_Squibb.dcb7d286.png";